import { findElementByIdForSnap } from 'packages/common/editor/timeline/tracks/dragging/snapping';
import { findElementById } from 'packages/common/editor/helpers/elementtree';

export const leftToStartFrame = (trackDuration, left) => {
    return left && Math.round((trackDuration / 100) * left);
};

export const widthToDuration = (trackDuration, width) => {
    return width && Math.round((trackDuration / 100) * width);
};

export const TRACK_HEIGHT = 44;

export const computeOverflow = (elementContainerRef) => {
    const elementNodes = elementContainerRef.current.querySelectorAll('.timeline__element');
    const rightMost = [].reduce.call(
        elementNodes,
        (acc, el) => {
            const { right } = el.getBoundingClientRect();

            return right > acc ? right : acc;
        },
        0,
    );

    const containerBoundingBox = elementContainerRef.current.getBoundingClientRect();
    const containerWidth = containerBoundingBox.width;
    const overflowAmount = rightMost - containerBoundingBox.right;

    const overflow = 100 / (1 + containerWidth / overflowAmount);
    const overflowRaw = overflowAmount / (containerWidth / 100);

    return [Math.max(overflow, 0), Math.max(overflowRaw, 0)];
};

export const pixelToPercentage = (trackWidth, subWidth) => {
    return (subWidth / trackWidth) * 100;
};

export const getDropCommand = (dropParams) => {
    const { isCtrlHeld, onGroup, inGroup, isExpanded, onElement } = dropParams;

    if (onElement) {
        return isCtrlHeld ? 'createGroup' : 'update';
    }

    if (inGroup || isExpanded) {
        return 'addToGroup';
    }

    if (onGroup && isCtrlHeld) {
        return 'addToGroup';
    }

    return 'update';
};

export const computeResizeSnapResults = (
    elements,
    { toLeft, fromRight, elementId: snapElementId },
    elementId,
    leftPercentage,
    width,
    trackDuration,
) => {
    let startFrame: number;
    let duration: number;

    if (snapElementId) {
        const snapElementMetaData = findElementByIdForSnap(elements, snapElementId, trackDuration);
        const element = findElementById(elements, elementId);
        const coef = toLeft ? 0 : 1;

        if (fromRight) {
            duration = snapElementMetaData.startFrame + coef * snapElementMetaData.duration - element.startFrame;
            startFrame = element.startFrame;
        } else {
            startFrame = snapElementMetaData.startFrame + coef * snapElementMetaData.duration;
            const deltaStartFrame = element.startFrame - startFrame;
            duration = element.duration + deltaStartFrame;
        }
    } else {
        duration = widthToDuration(trackDuration, width);
        startFrame = leftToStartFrame(trackDuration, leftPercentage);
    }

    return { startFrame, duration };
};
